import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from './../Icons'

const NotificationPopup = ({ handleClose, item }) => {
  const { t } = useTranslation(['notifications-portal'])
  return (
    <div className="ctp-notification-popup">
      <div className="ctp-notification-popup__window">
        <div className="ctp-notification-popup__header">
          <h1>{item.title}</h1>
          <div className="ctp-notification-popup__close" onClick={handleClose}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="ctp-notification-popup__body">
          {item.file && (
            <img
              src={`data:image/png;base64, ${item.file}`}
              alt={t('notifications-portal:popup.imageAlt')}
            />
          )}
          <p>{item.description}</p>
        </div>
      </div>
    </div>
  )
}

NotificationPopup.propTypes = {
  handleClose: PropTypes.func,
  item: PropTypes.object,
}

export default NotificationPopup
